/* ============================================================
   Get Joy — FDR PDP v10 · buy box + page personalization
   Reads quiz state (localStorage 'gj_quiz_state_v1' or URL params),
   derives classic/plan/landing state, runs the approved pricing
   model, and wires /cart/add.js with Skio selling plan + line props.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- config ---------- */
  var cfgEl = document.getElementById('gjx-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  // Per-bag pricing derives from the live variant price (Shopify admin) when the
  // section passes it in CFG.variantData; the fallbacks match the approved model.
  var FIRST_ORDER_PCT = 4446; // 44.46% (SupaEasy "50% off your first order"), in basis points
  function firstOrder(spCents) { return (spCents - Math.floor(spCents * FIRST_ORDER_PCT / 10000)) / 100; }
  function bagPrices(protein) {
    var vd = (CFG.variantData || {})[protein] || {};
    var full = parseFloat(vd.price) || 49.94;
    return {
      OTP_FULL: full,
      // First box = what checkout actually charges: the first-order function takes 44.46% off the subscription
      // price (≈ 50% off list), floored to the cent per unit. Verified in cart: $49.95 bag → $44.96 → $24.98; at $49.94 (Oct 8) → $44.95 → $24.97, exactly half.
      SUB_FIRST: firstOrder(Math.round(full * 90)),
      SUB_RENEW: Math.round(full * 90) / 100
    };
  }
  var fmt = function (n) { return '$' + n.toFixed(2); };
  // Weekly value = box total ÷ weeks, rounded half-up to the cent in integer cents (same rule as the quiz and the FAQ's Liquid math).
  function perWeek(total, weeks) { return Math.round(Math.round(total * 100) / weeks) / 100; }
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- pricing & portions (README §4 — must match exactly) ---------- */
  var CUP_TABLE = [[5, .5], [10, 1], [15, 1.25], [30, 2.25], [50, 3.75], [75, 5], [100, 6]];
  function cupsFor(w) {
    if (w <= 5) return .5;
    if (w >= 100) return 6;
    for (var i = 1; i < CUP_TABLE.length; i++) {
      if (w <= CUP_TABLE[i][0]) {
        var w0 = CUP_TABLE[i - 1][0], c0 = CUP_TABLE[i - 1][1], w1 = CUP_TABLE[i][0], c1 = CUP_TABLE[i][1];
        return c0 + (w - w0) / (w1 - w0) * (c1 - c0);
      }
    }
    return 6;
  }
  function cupStr(n) {
    var r = Math.round(n * 4) / 4, i = Math.floor(r), f = +(r - i).toFixed(2);
    var fr = { 0: '', 0.25: '¼', 0.5: '½', 0.75: '¾' }[f] || '';
    return ((i || !fr) ? i : '') + fr || '¼';
  }

  var BAG_CUPS = 12; // ~12 cups in a 32 oz bag (back-of-bag label)
  // Meals: never short. A 4-week (or one-time) box always covers a full month (30+ days); other cadences cover their full interval.
  // Toppers: whole bags, rounded up.
  function mealTarget(days) { return days === 28 ? 30 : days; }
  function bagsFor(days, topper, topCupN, cups) {
    return topper ? Math.max(1, Math.ceil(topCupN * days / BAG_CUPS)) : Math.max(1, Math.ceil(cups * mealTarget(days) / BAG_CUPS - 1e-9));
  }
  function planFor(weeks) {
    var p = (CFG.plans || {})[String(weeks)];
    return p ? parseInt(p, 10) : 0;
  }
  function freqsAvailable() {
    return [2, 4, 6].filter(function (f) { return f === 4 || !!planFor(f); }).filter(function (f) { return !!document.querySelector('[data-gjx-freq="' + f + '"]'); });
  }
  var COVER_TOL_SHORT = -4, COVER_TOL_OVER = 6; // days either side of the delivery date that still count as "on time"

  /* ---------- quiz state ---------- */
  function readQuiz() {
    var a = null;
    try {
      var raw = localStorage.getItem('gj_quiz_state_v1');
      if (raw) {
        var s = JSON.parse(raw);
        if (s && s.a && s.a.name && s.a.weight && (s.screen === 'plan' || s.screen === 'build')) a = s.a;
      }
    } catch (e) { /* private mode */ }
    // URL params override / fallback so emailed links work without localStorage
    try {
      var p = new URLSearchParams(location.search);
      if (p.get('dog') && p.get('w')) {
        a = a || {};
        a.name = p.get('dog').replace(/[<>&"']/g, '').slice(0, 40);
        a.weight = parseInt(p.get('w'), 10) || a.weight || 30;
        var pp = p.get('protein'), pm = p.get('mode'), pg = p.get('goal');
        if (pp === 'beef' || pp === 'chicken') a.protein = pp;
        if (pm === 'topper' || pm === 'meal') a.mode = pm;
        if (pg && GOAL_WORD.hasOwnProperty(pg)) { a.goals = [pg]; }
        var pa = parseFloat(p.get('age'));
        if (isFinite(pa) && pa >= 0 && pa < 30) a.age = pa;
        a.goals = a.goals || [];
        a.food = a.food || [];
      }
    } catch (e) { }
    // sanitize whatever came from storage or the URL before it drives copy or math
    if (a) {
      a.name = (typeof a.name === 'string' ? a.name : '').replace(/[<>&"']/g, '').slice(0, 40);
      var wNum = parseFloat(a.weight);
      a.weight = isFinite(wNum) ? Math.max(2, Math.min(200, Math.round(wNum))) : 30;
      if (Object.prototype.toString.call(a.goals) !== '[object Array]') a.goals = [];
      if (Object.prototype.toString.call(a.food) !== '[object Array]') a.food = [];
      if (!a.name) a = null;
    }
    return a;
  }

  /* ---------- personalization maps (README §7) ---------- */
  var GOAL_WORD = { digestion: 'working on digestion', skin: 'working on skin and coat', picky: 'a picky eater', weight: 'working on a healthy weight', joints: 'working on joints', calm: 'working on calm', dental: 'working on breath and teeth', energy: 'building energy' };
  var GOAL_SHORT = { digestion: 'digestion', skin: 'skin & coat', picky: 'picky appetite', weight: 'healthy weight', joints: 'joints', calm: 'calm', dental: 'breath & teeth', energy: 'energy' };
  var GOAL_ICON = { digestion: 'Quiz_Improve_Poop.webp', skin: 'Quiz_Improve_SkinCoat.webp', calm: 'Quiz_Improve_Anxious.webp', joints: 'Quiz_Improve_Joint.webp', weight: 'Quiz_Improve_Weight.webp', dental: 'Quiz_Improve_BadBreath.webp', picky: 'Quiz_Improve_PickyEater.webp', energy: 'Quiz_Improve_Wellness.webp' };
  var GOAL_TILE_IDX = { digestion: 0, skin: 1, calm: 2, joints: 3, weight: 4, dental: 5, picky: 6, energy: 7 };
  var ICON_BASE = 'https://getjoyfood.com/cdn/shop/files/';

  /* ---------- state ---------- */
  var quiz = readQuiz();
  var root = document.querySelector('[data-gjx-root]');
  var landingConcern = root ? root.getAttribute('data-gjx-landing') : '';
  var S = {
    page: quiz ? 'plan' : (landingConcern ? 'landing' : 'classic'),
    weight: quiz && quiz.weight ? Math.max(5, Math.min(100, Math.round(quiz.weight / 5) * 5)) : 30,
    mode: quiz ? ((quiz.mode === 'topper' || (!quiz.mode && quiz.prep === 'mixed')) ? 'topper' : 'meal') : 'meal',
    protein: (quiz && quiz.protein) || (root && root.getAttribute('data-gjx-protein')) || 'beef',
    buyType: 'sub',
    freq: 4,          // delivery frequency in weeks (subscription); 4 is the recommended default
    bagAdj: 0,        // shopper's +/- bag tweak from the coverage line; resets when the amount drivers change
    hName: '',        // name from the portion helper (does not switch the page into quiz plan state)
    hStage: '',       // life stage from the portion helper
    addons: {},
    editing: false,
    gal: 0,
    vid: 0,
    vidOpen: false,
    sticky: false
  };
  var exactWeight = quiz && quiz.weight ? quiz.weight : null; // for copy; slider snaps to 5s

  function derived() {
    var a = quiz || {};
    var w = exactWeight || S.weight;
    var topper = S.mode === 'topper';
    var ageN = parseFloat(a.age);
    var stage = !isNaN(ageN) ? (ageN < 1 ? 'puppy' : ageN >= 8 ? 'senior' : 'adult') : (S.hStage || 'adult');
    var name = (a.name || '').trim();
    var coverName = name || S.hName;
    var isPlan = S.page === 'plan' && !!name;
    var goals = (a.goals && a.goals.length) ? a.goals : (landingConcern ? ({ picky: ['picky'], gut: ['digestion'], itchy: ['skin'] }[landingConcern] || ['digestion']) : ['digestion']);
    var topCup = w < 25 ? '¼' : w < 50 ? '⅓' : '½';
    var topCupN = w < 25 ? .25 : w < 50 ? 1 / 3 : .5;
    var cups = cupsFor(w);
    // Bags per delivery scale with the cadence so the daily amount never changes (4 weeks = the approved model, unchanged).
    var days = S.buyType === 'sub' ? S.freq * 7 : 28;
    var daily = topper ? topCupN : cups;
    // Round 27: each card is priced from its own amount, whichever card is selected.
    // Subscribe = the chosen cadence (+ any coverage tweak). One-time trial = the same month of food as the 4-week plan,
    // so switching cards never changes how much food the dog gets — only how it's paid for.
    var subBags = Math.max(1, bagsFor(S.freq * 7, topper, topCupN, cups) + S.bagAdj);
    var otpBags = Math.max(1, bagsFor(28, topper, topCupN, cups) + (S.freq === 4 ? S.bagAdj : 0));
    var baseBags = bagsFor(days, topper, topCupN, cups);
    var bags = S.buyType === 'sub' ? subBags : otpBags;
    var coverDays = Math.floor(bags * BAG_CUPS / daily);
    var PRICES = bagPrices(S.protein);
    var subFirst = subBags * PRICES.SUB_FIRST, subRenew = subBags * PRICES.SUB_RENEW, subFull = Math.round(subBags * PRICES.OTP_FULL * 100) / 100;
    var otpFull = Math.round(otpBags * PRICES.OTP_FULL * 100) / 100, otpNew = Math.round(otpBags * (PRICES.OTP_FULL - Math.floor(PRICES.OTP_FULL * 25) / 100) * 100) / 100; // Shopify allocates the 25% code per unit, floored ($59.95 → $44.97/bag)
    var perDay = subFirst / (S.freq * 7);
    // Round 25 (weekly value): every price is shown per week of the delivery cadence. A one-time box is a month's food,
    // so it reads over 4 weeks. Box totals stay visible next to every weekly figure (renewal-law disclosure).
    var weeks = S.buyType === 'sub' ? S.freq : 4;
    var wkFirst = perWeek(subFirst, S.freq), wkRenew = perWeek(subRenew, S.freq), wkSubFull = perWeek(subFull, S.freq), wkOtp = perWeek(otpNew, 4), wkFull = perWeek(otpFull, 4);
    var addonTotal = 0;
    (CFG.addons || []).forEach(function (ad) { if (S.addons[ad.id]) addonTotal += parseFloat(ad.price); });
    var boxTotal = (S.buyType === 'otp' ? otpNew : subFirst) + addonTotal;
    var proteinLabel = S.protein === 'beef' ? 'Beef' : 'Chicken';
    var breedWord = (a.breed && a.breed !== 'Other') ? (a.breed === 'Mixed breed' ? 'mixed-breed dog' : a.breed) : null;
    var dogDesc = breedWord ? (stage === 'puppy' ? breedWord.replace(/ dog$/, '') + ' puppy' : (stage === 'adult' ? '' : stage + ' ') + breedWord) : (stage === 'adult' ? 'dog' : stage === 'puppy' ? 'puppy' : 'senior dog');
    var goalWord = GOAL_WORD[goals[0]] || 'ready for a gut-first bowl';
    var reasonTail = ({
      digestion: 'gentle sorghum and pumpkin, with the full Belly Biotics™ system',
      skin: 'omega-3s from salmon oil and flaxseed for skin and coat',
      picky: 'the recipe picky eaters devour first',
      weight: 'nutrient-dense and portioned precisely to ' + w + ' lb',
      joints: 'omega-3s plus precise portions that keep weight off the joints',
      calm: 'a calmer gut often means a steadier dog',
      dental: 'Belly Biotics™ dogs show an improved oral microbiome',
      energy: 'more absorbed nutrition means more energy at the park'
    })[goals[0]] || 'the recipe most dogs devour first';
    var bodyNote = ({ 'More to Love': 'Portioned to get ' + name + ' back to a healthy weight — precise portions, not free feeding.', 'A Bit Skinny': 'Portioned to put healthy weight on ' + name + ', meal by meal.' })[a.body] || '';
    var stageNote = stage === 'puppy' ? ('Made for a growing puppy: complete & balanced for all life stages (AAFCO), including puppies who grow past 70 lb, with Belly Biotics™ building a healthy gut from the start. As ' + (name || 'they') + ' grow' + (name ? 's' : '') + ', update the weight and the plan grows too.') : stage === 'senior' ? ('Gentle on senior stomachs — and the month-3 joint and dental reset matters most for ' + name + '.') : '';
    var prepLine = isPlan ? ({ dry: 'You chose serve dry — pour ' + name + "'s portion straight in, no prep.", hydrated: 'You chose hydrated — add ⅓ cup warm water per cup and give it 60 seconds.', mixed: 'You chose mixed-in — ' + topCup + ' cup a day over ' + name + "'s current food." })[a.prep] || '' : '';
    return {
      a: a, w: w, name: name, isPlan: isPlan, topper: topper, stage: stage,
      stageLabel: { puppy: 'Puppy', adult: 'Adult', senior: 'Senior' }[stage],
      goals: goals, goalWord: goalWord, reasonTail: reasonTail, bodyNote: bodyNote, stageNote: stageNote, prepLine: prepLine,
      dogDesc: dogDesc, proteinLabel: proteinLabel,
      topCup: topCup, topCupN: topCupN, cups: cups, bags: bags, baseBags: baseBags, days: days, daily: daily, coverDays: coverDays, coverName: coverName,
      subBags: subBags, otpBags: otpBags, subFull: subFull, wkSubFull: wkSubFull,
      subFirst: subFirst, subRenew: subRenew, subFull: subFull, otpFull: otpFull, otpNew: otpNew, perDay: perDay, boxTotal: boxTotal,
      weeks: weeks, wkFirst: wkFirst, wkRenew: wkRenew, wkOtp: wkOtp, wkFull: wkFull,
      fromKibble: (a.food || []).indexOf('Kibble') >= 0,
      brandName: (a.brand || '').trim()
    };
  }

  /* ---------- DOM helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }
  function show(sel, on) { $$(sel).forEach(function (el) { el.hidden = !on; }); }

  // Bag image: the variant's featured image from the product admin wins;
  // the FOP webp is the fallback so the page never shows an empty bag slide.
  var BAG_FALLBACK = {
    beef: ICON_BASE + 'GJ_PDP_FDR_Beef-FOP.webp?v=1785277204&width=900',
    chicken: ICON_BASE + 'GJ_PDP_FDR_Chicken-FOP.webp?v=1785277203&width=900'
  };
  function bagImg(protein) {
    var vd = (CFG.variantData || {})[protein] || {};
    return vd.img || BAG_FALLBACK[protein];
  }
  var GAL_N = Math.max(1, $$('[data-gjx-slide]').length);
  function galList() {
    var out = [];
    $$('[data-gjx-slide]').forEach(function (sl) { var f = sl.getAttribute('data-flavor'); if (!f || f === 'all' || f === S.protein) out.push(+sl.getAttribute('data-gjx-slide')); });
    return out.length ? out : [0];
  }

  /* ---------- render ---------- */
  function render() {
    var d = derived();
    var isPlan = d.isPlan, name = d.name || 'your dog';
    var poss = isPlan ? name + "'s" : 'their';

    // page-state blocks
    show('[data-gjx-show=classic]', S.page === 'classic');
    show('[data-gjx-show=landing]', S.page === 'landing');
    show('[data-gjx-show=plan]', isPlan);

    if (isPlan) {
      setText('[data-gjx=dog-name]', name);
      // Personalized product description (same message as the classic hero copy, rewritten around their answers).
      var GOAL_OUTCOME = { digestion: 'firmer, happier poops', skin: 'a calmer, shinier coat', picky: 'a bowl they actually finish', weight: 'a healthy weight', joints: 'easier movement', calm: 'a steadier, calmer dog', dental: 'fresher breath', energy: 'all-day energy' };
      var outc = GOAL_OUTCOME[d.goals[0]];
      var tailYears = d.stage === 'puppy' ? 'a strong start to a lifetime of healthy, happy years' : d.stage === 'senior' ? 'more healthy, happy years together' : 'more healthy, happy years';
      var art = /^8|^1[18]$/.test(String(d.w)) ? 'an' : 'a';
      setText('[data-gjx=playback]', 'Freeze Dried Raw ' + (d.topper ? 'Topper' : 'Meals') + ' for ' + art + ' ' + d.w + ' lb ' + d.dogDesc + ', crafted with 100% superfoods, premium protein, and Belly Biotics™—a blend of prebiotics, probiotics, and postbiotics—to support a balanced gut' + (outc ? ', ' + outc + ',' : '') + ' and ' + tailYears + '.');
    }

    // bag images (gallery slide 0, thumb 0, sticky, close)
    $$('[data-gjx-bagimg]').forEach(function (el) { el.style.backgroundImage = "url('" + bagImg(S.protein) + "')"; });

    // buy box title + steps vs profile chip
    var bt = $('[data-gjx=buy-title]');
    if (bt) {
      var nm = isPlan ? name : S.hName;
      var tNamed = bt.getAttribute('data-title-named') || "Build [name]'s gut-healthy bowl", tPlain = bt.getAttribute('data-title') || 'Build their gut-healthy bowl';
      // Round 33: gut-healthy bowl is the default. When the quiz tells us their top goal, the title speaks to it (claims-safe wording).
      var GOAL_TITLE = { picky: 'Build a bowl [name] will finish', skin: "Build [name]'s skin & coat bowl", weight: "Build [name]'s healthy-weight bowl" };
      var tGoal = isPlan && d.goals && GOAL_TITLE[d.goals[0]];
      bt.textContent = nm ? (tGoal || tNamed).replace(/\[name\]|\{name\}/g, nm) : tPlain;
    }
    show('[data-gjx=profile-chip]', isPlan && !S.editing);
    show('[data-gjx=steps]', !isPlan || S.editing);
    show('[data-gjx=rec-row]', isPlan && !S.editing);
    show('[data-gjx=mode-switch]', isPlan && !S.editing);
    show('[data-gjx=buy-quiz-nudge]', !isPlan && !quiz);
    if (isPlan) {
      setText('[data-gjx=profile-line]', ''); // rebuilt below
      var pl = $('[data-gjx=profile-line]');
      if (pl) pl.innerHTML = '<strong>' + esc(name) + '</strong> · ' + d.w + ' lb · ' + d.stageLabel + ' · ' + d.proteinLabel;
      var chips = $('[data-gjx=goal-chips]');
      if (chips) {
        chips.innerHTML = d.goals.map(function (g) {
          var s = GOAL_SHORT[g] || g;
          return '<span class="gjx-goal-chip"><img src="' + ICON_BASE + (GOAL_ICON[g] || 'Quiz_Improve_Wellness.webp') + '" alt="">' + s.charAt(0).toUpperCase() + s.slice(1) + '</span>';
        }).join('');
      }
    }

    // steps
    var slider = $('[data-gjx=weight-slider]');
    if (slider && +slider.value !== S.weight) slider.value = S.weight;
    setText('[data-gjx=weight-val]', S.weight + ' lb');
    $$('[data-gjx-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-gjx-mode') === S.mode ? 'true' : 'false'); });
    $$('[data-gjx-protein]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-gjx-protein') === S.protein ? 'true' : 'false'); });

    // spec row
    var q = Math.round(d.cups * 4) / 4;
    // Round 25: no bag counts in the UI. The amount is the daily scoop our nutritionist recommends; bags stay behind the scenes (cart quantity).
    setText('[data-gjx=amt-src]', (d.topper ? 'on top of their food · ' : '') + 'recommended for ' + (d.coverName ? d.coverName + ' (' + d.w + ' lb)' : 'a ' + d.w + ' lb dog') + ' by our Ph.D. animal nutritionist');
    renderCover(d);
    renderFreq(d);
    setText('[data-gjx=feed-preview]', d.topper ? d.topCup + ' cup a day on top' : cupStr(d.cups) + (q <= 1 ? ' cup' : ' cups') + ' a day');
    setText('[data-gjx=spec-cups]', d.topper ? d.topCup + ' cup' : cupStr(d.cups) + (q <= 1 ? ' cup' : ' cups'));
    setText('[data-gjx=spec-cups-k]', d.topper ? '/ day on top' : '/ day');
    setText('[data-gjx=plan-tail]', d.topper
      ? (d.proteinLabel + ' topper for ' + (isPlan ? name + "'s" : 'their') + ' current food · first box 50% off')
      : ('4 weeks of ' + d.proteinLabel + ' meals · first box 50% off'));

    // why rows (plan)
    var why = $('[data-gjx=why-rows]');
    if (why) {
      var rows = ['We recommend ' + d.proteinLabel + ' — ' + d.reasonTail + '.', [d.bodyNote, d.stageNote].filter(Boolean).join(' ')].filter(Boolean);
      why.innerHTML = rows.map(function (r) { return '<div class="gjx-why-row"><span class="gjx-check">✓</span><span>' + esc(r) + '</span></div>'; }).join('');
      setText('[data-gjx=why-name]', name);
    }

    // plan cards
    $$('[data-gjx-buytype]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-gjx-buytype') === S.buyType ? 'true' : 'false'); });
    $$('[data-gjx-card]').forEach(function (c) { c.setAttribute('data-on', c.getAttribute('data-gjx-card') === S.buyType ? 'true' : 'false'); });
    // Round 33 (Tom, Oct 9): every card leads with the box total and shows the weekly price right next to it.
    // R54: every cadence reads in weeks ("/4 wks", "every 4 weeks") to match the drawer and checkout.
    var unit = '/' + S.freq + ' wks';
    setText('[data-gjx=sub-total]', fmt(d.subFirst));
    setText('[data-gjx=sub-unit]', unit);
    setText('[data-gjx=sub-first]', fmt(d.wkFirst) + '/wk');
    setText('[data-gjx=sub-strike]', fmt(d.subFull)); // strike = full price of the same box, so "50% off first box" reads true
    setText('[data-gjx=sub-terms]', 'Then ' + fmt(d.subRenew) + ' every ' + S.freq + ' weeks (' + fmt(d.wkRenew) + '/wk) · skip, pause or cancel anytime');
    setText('[data-gjx=otp-total]', fmt(d.otpNew));
    var ps = $('[data-gjx=plan-sum]');
    if (ps) {
      var amt = d.topper ? d.topCup + ' cup a day on top' : cupStr(d.cups) + (d.cups <= 1 ? ' cup' : ' cups') + ' a day';
      var sumHtml = '<strong>Your plan</strong> ' + esc(d.w) + ' lb · ' + esc(d.proteinLabel) + ' · ' + (d.topper ? 'Topper' : 'Full bowl') + ' · ' + esc(amt) + ' · ' + (S.buyType === 'otp' ? 'one-time box' : 'ships every ' + S.freq + ' weeks');
      if (ps.innerHTML !== sumHtml) ps.innerHTML = sumHtml;
    }
    setText('[data-gjx=otp-terms]', 'One-time order — no Auto-Ship. Reorder anytime.');
    setText('[data-gjx=sub-save]', fmt(Math.round((d.otpFull - d.subFirst) * 100) / 100));
    setText('[data-gjx=per-day]', fmt(d.perDay) + '/day');
    setText('[data-gjx=month-line]', d.bags + ' × 32 oz bag' + (d.bags > 1 ? 's' : '') + ' · 4 weeks of ' + (d.topper ? 'daily toppers' : 'meals'));
    setText('[data-gjx=sub-renew]', fmt(d.subRenew));
    setText('[data-gjx=otp-new]', fmt(d.wkOtp) + '/wk');
    setText('[data-gjx=otp-strike]', fmt(d.otpFull));

    // CTA
    // Oct 7: plain retail CTA ("Add to cart") for both delivery options — the price always matches the selected row.
    var ctaLabel = 'Add to cart — ' + fmt(d.boxTotal);
    setText('[data-gjx=cta-label]', ctaLabel);
    setText('[data-gjx=close-cta-label]', ctaLabel);
    setText('[data-gjx=close-eyebrow]', isPlan ? name + "'s plan is ready" : 'Ready when they are');
    var cp = $('[data-gjx=close-price]');
    if (cp) {
      cp.innerHTML = S.buyType === 'otp'
        ? '4-week trial · ' + fmt(d.otpNew) + '/4 wks <span class="gjx-strike">' + fmt(d.otpFull) + '</span> · ' + fmt(d.wkOtp) + '/wk'
        : 'Auto-Ship · first box ' + fmt(d.subFirst) + ' <span class="gjx-strike">' + fmt(d.subFull) + '</span> · ' + fmt(d.wkFirst) + '/wk · then ' + fmt(d.subRenew) + unit;
    }

    // feeding guide highlight + prep line
    var idx = S.weight <= 10 ? 0 : S.weight <= 25 ? 1 : S.weight <= 50 ? 2 : S.weight <= 75 ? 3 : 4;
    $$('[data-gjx-feedrow]').forEach(function (r, i) { r.classList.toggle('is-active', i === idx); });
    var prep = $('[data-gjx=prep-line]');
    if (prep) { prep.hidden = !d.prepLine; prep.textContent = d.prepLine; }

    // gallery slides
    var gl = galList(); if (gl.indexOf(S.gal) < 0) S.gal = gl[0];
    $$('[data-gjx-slide]').forEach(function (sl) { sl.hidden = +sl.getAttribute('data-gjx-slide') !== S.gal; });
    $$('[data-gjx-thumb]').forEach(function (t) { var i = +t.getAttribute('data-gjx-thumb'); t.hidden = gl.indexOf(i) < 0; t.setAttribute('aria-pressed', i === S.gal ? 'true' : 'false'); });
    // Keep the active thumb in view inside the strip (horizontal only — never scrolls the page).
    var strip = $('.gjx-gal-thumbs'), at = $('[data-gjx-thumb][aria-pressed=true]');
    if (strip && at && strip.scrollWidth > strip.clientWidth) {
      var sr = strip.getBoundingClientRect(), ar = at.getBoundingClientRect(), sl = strip.scrollLeft;
      var l = ar.left - sr.left + sl, r = l + ar.width;
      if (l < sl + 8) strip.scrollLeft = Math.max(0, l - 8);
      else if (r > sl + strip.clientWidth - 8) strip.scrollLeft = r - strip.clientWidth + 8;
    }

    // sticky bar
    var sticky = $('[data-gjx=sticky]');
    if (sticky) {
      sticky.hidden = !S.sticky;
      setText('[data-gjx=sticky-title]', isPlan ? name + "'s Plan" : 'Freeze Dried Raw');
      setText('[data-gjx=sticky-sub]', d.proteinLabel + (d.topper ? ' topper' : ' meals'));
      var stUnit = S.buyType === 'otp' ? '/4 wks' : unit;
      setText('[data-gjx=sticky-price]', fmt(S.buyType === 'otp' ? d.otpNew : d.subFirst) + stUnit);
      setText('[data-gjx=sticky-was]', fmt(S.buyType === 'otp' ? d.otpFull : d.subFull)); // same anchor as the buy box card
      setText('[data-gjx=sticky-perday]', '· ' + fmt(S.buyType === 'otp' ? d.wkOtp : d.wkFirst) + '/wk');
      setText('[data-gjx=sticky-cta-label]', 'Add to cart');
    }

    // ingredients / GA per protein
    show('[data-gjx-flat=beef]', S.protein === 'beef');
    show('[data-gjx-flat=chicken]', S.protein === 'chicken');
    show('[data-gjx-ga=beef]', S.protein === 'beef');
    show('[data-gjx-ga=chicken]', S.protein === 'chicken');
    setText('[data-gjx=protein-label]', d.proteinLabel);
    show('[data-gjx-ing-protein=beef]', S.protein === 'beef');
    show('[data-gjx-ing-protein=chicken]', S.protein === 'chicken');

    // personalized section headings
    setText('[data-gjx=concerns-head]', isPlan ? 'What ' + name + ' needs help with.' : 'Where do they need a little extra support?');
    var swEl = $('[data-gjx=switch-line]');
    if (swEl) {
      var line = '';
      if (isPlan) {
        line = d.topper
          ? name + ' is on the topper plan — no switch needed. Start with ' + d.topCup + ' cup on day one.'
          : name + "'s 7-day switch" + (d.fromKibble ? (d.brandName ? ' from ' + d.brandName : ' from kibble') : '') + ' — a quarter, then half, then three-quarters, then the good bowl.';
      }
      swEl.hidden = !line;
      var swTx = $('[data-gjx=switch-line-text]');
      if (swTx) swTx.textContent = line;
    }

    // add-on buttons (all instances share state)
    $$('[data-gjx-addon]').forEach(function (b) {
      var id = b.getAttribute('data-gjx-addon');
      var on = !!S.addons[id];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.classList.contains('gjx-add-btn')) b.textContent = on ? '\u2713 In first box' : '+ Add to box';
    });
    var totalRow = $('[data-gjx=box-total-row]');
    if (totalRow) {
      var count = Object.keys(S.addons).filter(function (k) { return S.addons[k]; }).length;
      totalRow.hidden = count === 0;
      setText('[data-gjx=box-total]', fmt(d.boxTotal));
    }
    // "In your first box" strip above the CTA — makes the CTA total transparent when add-ons are toggled elsewhere on the page
    var boxRow = $('[data-gjx=box-addons]');
    if (boxRow) {
      var active = (CFG.addons || []).filter(function (ad) { return S.addons[ad.id]; });
      boxRow.hidden = active.length === 0;
      boxRow.innerHTML = active.length ? '<div class="gjx-box-addons-h">Also in your first box</div>' + active.map(function (ad) {
        return '<div class="gjx-box-addon"><span class="n">' + ad.name + '</span><span class="p">+ ' + fmt(parseFloat(ad.price)) + '</span><button type="button" class="x" data-gjx-addon="' + ad.id + '" aria-label="Remove ' + ad.name.replace(/<[^>]+>/g, '') + '">×</button></div>';
      }).join('') + '<div class="gjx-box-addon gjx-box-addon--sum"><span class="n">First box total</span><span class="p">' + fmt(d.boxTotal) + '</span></div>' : '';
    }
  }

  /* ---------- coverage line + frequency (Round 21) ---------- */
  // One plain sentence that ties the amount to the cadence: "5 bags · ~26 days of meals for Biscuit · lands right on your next delivery".
  // When the order drifts (shopper tweak, topper, tiny dogs), it offers the single best one-tap fix.
  function coverFixes(d) {
    var target0 = d.topper ? d.days : mealTarget(d.days), diff0 = d.coverDays - target0;
    var out = [];
    var mk = function (label, bags, days, apply) {
      var cd = Math.floor(bags * BAG_CUPS / d.daily), tg = d.topper ? days : mealTarget(days);
      return { label: label, diff: cd - tg, apply: apply };
    };
    var bagDays = Math.round(BAG_CUPS / d.daily);
    out.push(mk('Add ~' + bagDays + ' days of food', d.bags + 1, d.days, function () { S.bagAdj++; }));
    if (d.bags > 1) out.push(mk('Trim ~' + bagDays + ' days', d.bags - 1, d.days, function () { S.bagAdj--; }));
    if (S.buyType === 'sub') {
      freqsAvailable().forEach(function (f) {
        if (f === S.freq) return;
        var b = bagsFor(f * 7, d.topper, d.topCupN, d.cups);
        out.push(mk('Switch to every ' + f + ' weeks', b, f * 7, function () { S.freq = f; S.bagAdj = 0; }));
      });
    }
    // never "fix" an order into one that runs short (meals must still cover the full month / interval)
    out = out.filter(function (x) { return d.topper ? x.diff >= COVER_TOL_SHORT : x.diff >= 0; });
    // Round 29: prefer fixes that never run short (a topper that runs out 4 days early is worse for the dog and for retention
    // than the cadence that fits), then the closest fit.
    var rank = function (x) { return x.diff < 0 ? 100 + Math.abs(x.diff) : x.diff; };
    out.sort(function (x, y) { return rank(x) - rank(y); });
    var best = out[0];
    return (best && Math.abs(best.diff) + 3 <= Math.abs(diff0)) ? best : null;
  }
  var coverFix = null;
  function renderCover(d) {
    var el = $('[data-gjx=cover]');
    if (!el) return;
    var what = d.topper ? 'toppers' : 'meals';
    var who = d.coverName ? ' for ' + d.coverName : '';
    // The bag count already sits in the amount row above, so this caption only says how long it lasts.
    var head = '~' + d.coverDays + ' days of ' + what + who;
    var target = d.topper ? d.days : mealTarget(d.days);
    var diff = d.coverDays - target, status = 'ok', tail = '';
    var month = d.days === 28;
    coverFix = null;
    if (S.buyType === 'sub') {
      var shortAt = d.topper ? COVER_TOL_SHORT : 0, overAt = d.topper ? COVER_TOL_OVER : 10;
      if (diff < shortAt) { status = 'short'; tail = 'runs out ~' + (target - d.coverDays) + ' days before the next box'; }
      else if (diff > overAt) { status = 'over'; tail = '~' + (d.coverDays - d.days) + ' extra days each delivery'; }
      else tail = month && !d.topper ? 'a full 4 weeks, every delivery' : 'lands right on your next delivery';
      if (status !== 'ok') coverFix = coverFixes(d);
      // Toppers are sold by the whole bag (rounded up), so a little to spare is expected: say it calmly, still offer the better fit.
      if (status === 'over' && d.topper) { status = 'spare'; tail = 'covers the ' + S.freq + ' weeks with ~' + (d.coverDays - d.days) + ' days to spare'; }
      else if (status === 'over' && !coverFix) tail += ' (push a delivery back anytime)';
    } else {
      tail = d.topper ? 'one delivery, no commitment' : '4 full weeks in one box';
    }
    el.setAttribute('data-status', status);
    setText('[data-gjx=cover-text]', head + ' · ' + tail);
    setText('[data-gjx=cover-ic]', (status === 'ok' || status === 'spare') ? '✓' : '!');
    var fx = $('[data-gjx=cover-fix]');
    if (fx) { fx.hidden = !coverFix; fx.textContent = coverFix ? coverFix.label : ''; }
    // One sizing affordance per state: quiz shoppers can retake the quiz; everyone else gets the size helper.
    var planSt = d.isPlan && !S.editing;
    $$('.gjx-cover [data-gjx=helper-open]').forEach(function (b) { b.hidden = planSt; });
    show('[data-gjx=retake]', planSt);
    var based = $('[data-gjx=cover-based]');
    if (based) {
      var showBased = !!(S.hName || S.hStage || d.stage === 'puppy');
      based.hidden = !showBased;
      if (showBased) based.textContent = 'Based on ' + d.w + ' lb · ' + d.stageLabel.toLowerCase() + ' · ' + (d.topper ? 'topper' : 'full bowl') + (d.stage === 'puppy' ? ' · growing pups may need more; adjust as they grow' : '');
    }
  }
  function renderFreq(d) {
    var box = $('[data-gjx=freq]');
    if (!box) return;
    box.hidden = S.buyType !== 'sub';
    box.setAttribute('data-open', S.freqOpen ? 'true' : 'false');
    setText('[data-gjx=freq-val]', S.freq + ' weeks');
    setText('[data-gjx=freq-word]', S.freq + ' weeks');
    // "Recommended" sits on the cadence whose whole-bag amount lands closest to the next delivery without running short:
    // 4 weeks (the default) whenever it fits, otherwise the cadence that does (e.g. 6 weeks for a ½-cup topper).
    var diffF = function (f) {
      var b = bagsFor(f * 7, d.topper, d.topCupN, d.cups);
      return Math.floor(b * BAG_CUPS / d.daily) - (d.topper ? f * 7 : mealTarget(f * 7));
    };
    var fitsF = function (f) { var x = diffF(f); return d.topper ? (x >= COVER_TOL_SHORT && x <= COVER_TOL_OVER) : (x >= 0 && x <= 10); };
    // 4 weeks whenever it fits; otherwise the cadence with the least leftover that never runs short.
    var recF = fitsF(4) ? 4 : freqsAvailable().slice().sort(function (x, y) {
      var dx = diffF(x), dy = diffF(y);
      return (dx < (d.topper ? COVER_TOL_SHORT : 0) ? 999 : dx) - (dy < (d.topper ? COVER_TOL_SHORT : 0) ? 999 : dy);
    })[0] || 4;
    show('[data-gjx=freq-rec]', S.freq === recF && S.bagAdj === 0);
    var tg = $('[data-gjx=freq-toggle]');
    if (tg) { tg.setAttribute('aria-expanded', S.freqOpen ? 'true' : 'false'); tg.textContent = S.freqOpen ? 'Done' : 'Change'; }
    var chips = $('.gjx-freq-chips');
    if (chips) chips.hidden = !S.freqOpen;
    $$('[data-gjx-freq]').forEach(function (b) {
      var f = +b.getAttribute('data-gjx-freq');
      b.setAttribute('aria-checked', f === S.freq ? 'true' : 'false');
      var n = bagsFor(f * 7, d.topper, d.topCupN, d.cups) + (f === S.freq ? S.bagAdj : 0);
      n = Math.max(1, n);
      var sp = b.querySelector('[data-gjx-freq-bags]');
      if (sp) sp.textContent = f === recF ? ' · recommended' : '';
    });
  }

  /* ---------- portion helper (bottom sheet) ---------- */
  var H = { name: '', weight: 30, stage: 'adult', mode: 'meal' }, helperReturn = null;
  function helperPreview() {
    var out = $('[data-gjx=h-out]');
    if (!out) return;
    var topper = H.mode === 'topper';
    var cups = cupsFor(H.weight), tcN = H.weight < 25 ? .25 : H.weight < 50 ? 1 / 3 : .5, tc = H.weight < 25 ? '¼' : H.weight < 50 ? '⅓' : '½';
    var days = S.freq * 7, b = bagsFor(days, topper, tcN, cups);
    var nm = H.name ? esc(H.name) : 'Your dog';
    var q = Math.round(cups * 4) / 4;
    var amt = topper ? tc + ' cup a day on top of their food' : cupStr(cups) + (q <= 1 ? ' cup' : ' cups') + ' a day';
    var bp = bagPrices(S.protein), wkF = fmt(perWeek(b * bp.SUB_FIRST, S.freq)), wkR = fmt(perWeek(b * bp.SUB_RENEW, S.freq));
    out.innerHTML = '<div class="gjx-sheet-out-k">' + nm + "'s plan</div>" +
      '<div class="gjx-sheet-out-v"><strong>' + amt + '</strong><span>~' + Math.floor(b * BAG_CUPS / (topper ? tcN : cups)) + ' days of ' + (topper ? 'toppers' : 'meals') + ', delivered every ' + S.freq + ' weeks</span>' +
      '<span>' + wkF + '/wk for the first box (50% off), then ' + wkR + '/wk · Belly Biotics™ in every scoop</span></div>' +
      (H.stage === 'puppy' ? '<div class="gjx-sheet-note">Growing puppies often need more than the adult amount. Start here, weigh them weekly and adjust: your plan changes in a tap.</div>' : '') +
      (H.stage === 'senior' ? '<div class="gjx-sheet-note">Less active seniors may need a little less. Keep an eye on their waistline and adjust anytime.</div>' : '');
    setText('[data-gjx=h-weight-val]', H.weight + ' lb');
    $$('[data-gjx-hstage]').forEach(function (x) { x.setAttribute('aria-checked', x.getAttribute('data-gjx-hstage') === H.stage ? 'true' : 'false'); });
    $$('[data-gjx-hmode]').forEach(function (x) { x.setAttribute('aria-checked', x.getAttribute('data-gjx-hmode') === H.mode ? 'true' : 'false'); });
  }
  function helperOpen(from) {
    var sh = $('[data-gjx=helper]');
    if (!sh) return;
    var d = derived();
    H.name = S.hName || d.name || '';
    H.weight = S.weight; H.stage = d.stage; H.mode = S.mode;
    var ni = $('[data-gjx=h-name]'); if (ni) ni.value = H.name;
    var wi = $('[data-gjx=h-weight]'); if (wi) wi.value = H.weight;
    helperPreview();
    helperReturn = from || null;
    sh.hidden = false;
    document.documentElement.classList.add('gjx-sheet-open');
    requestAnimationFrame(function () { sh.classList.add('is-in'); });
    var first = $('[data-gjx=h-weight]') || ni;
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }, 60);
    track('gjx_helper_open', {});
  }
  function helperClose() {
    var sh = $('[data-gjx=helper]');
    if (!sh || sh.hidden) return;
    sh.classList.remove('is-in');
    document.documentElement.classList.remove('gjx-sheet-open');
    setTimeout(function () { sh.hidden = true; }, 200);
    if (helperReturn && helperReturn.focus) { try { helperReturn.focus({ preventScroll: true }); } catch (e) {} }
  }
  function helperUse() {
    S.weight = H.weight; exactWeight = null; S.mode = H.mode; S.hStage = H.stage;
    S.hName = (H.name || '').replace(/[<>&"']/g, '').trim().slice(0, 24);
    S.bagAdj = 0; S.buyType = 'sub';
    helperClose();
    render();
    track('gjx_helper_use', { weight: S.weight, mode: S.mode, stage: S.hStage, named: !!S.hName });
    var cv = $('[data-gjx=cover]');
    if (cv) { cv.classList.remove('is-flash'); void cv.offsetWidth; cv.classList.add('is-flash'); cv.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-gjx=h-weight]')) { H.weight = +e.target.value; if (!hRaf) hRaf = requestAnimationFrame(function () { hRaf = 0; helperPreview(); }); }
    else if (e.target.matches('[data-gjx=h-name]')) { H.name = e.target.value.replace(/[<>&"']/g, '').slice(0, 24); helperPreview(); }
  });
  document.addEventListener('keydown', function (e) {
    var sh = $('[data-gjx=helper]');
    if (!sh || sh.hidden) return;
    if (e.key === 'Escape') { helperClose(); return; }
    if (e.key === 'Enter' && e.target.matches('[data-gjx=h-name]')) { e.preventDefault(); helperUse(); return; }
    if (e.key === 'Tab') { // keep focus inside the dialog
      var f = $$('button, input', sh.querySelector('.gjx-sheet-card')).filter(function (x) { return !x.disabled && x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gjx=helper-open],[data-gjx=helper-close],[data-gjx=helper-use],[data-gjx-hstage],[data-gjx-hmode],[data-gjx=freq-toggle],[data-gjx-freq],[data-gjx=cover-fix],[data-gjx-jump]');
    if (!t) return;
    if (t.matches('[data-gjx=helper-open]')) helperOpen(t);
    else if (t.matches('[data-gjx=helper-close]')) helperClose();
    else if (t.matches('[data-gjx=helper-use]')) helperUse();
    else if (t.hasAttribute('data-gjx-hstage')) { H.stage = t.getAttribute('data-gjx-hstage'); helperPreview(); }
    else if (t.hasAttribute('data-gjx-hmode')) { H.mode = t.getAttribute('data-gjx-hmode'); helperPreview(); }
    else if (t.matches('[data-gjx=freq-toggle]')) { S.freqOpen = !S.freqOpen; render(); }
    else if (t.hasAttribute('data-gjx-freq')) { S.freq = +t.getAttribute('data-gjx-freq'); S.bagAdj = 0; S.freqOpen = false; render(); track('gjx_frequency', { weeks: S.freq }); }
    else if (t.matches('[data-gjx=cover-fix]')) { if (coverFix) { var lbl = coverFix.label; coverFix.apply(); render(); track('gjx_cover_fix', { fix: lbl }); } }
    else if (t.hasAttribute('data-gjx-jump')) {
      var tgt = document.getElementById(t.getAttribute('data-gjx-jump'));
      if (!tgt) return;
      e.preventDefault();
      if (tgt.tagName === 'DETAILS') tgt.open = true;
      var which = t.getAttribute('data-gjx-open');
      if (which) { var acc = tgt.querySelector('[data-gjx-acc="' + which + '"]'); if (acc) acc.open = true; }
      tgt.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* ---------- events: buy box ---------- */
  document.addEventListener('input', function (e) {
    // Oct 14: one render per frame while dragging; analytics once, when the thumb is released
    if (e.target.matches('[data-gjx=weight-slider]')) { S.weight = +e.target.value; exactWeight = null; S.bagAdj = 0; if (!wRaf) wRaf = requestAnimationFrame(function () { wRaf = 0; render(); }); }
  });
  var wRaf = 0, hRaf = 0;
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-gjx=weight-slider]')) track('gjx_weight', { weight: S.weight });
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gjx-mode],[data-gjx-protein]:not([data-gjx-root]),[data-gjx-buytype],[data-gjx=profile-chip],[data-gjx-thumb],[data-gjx=gal-prev],[data-gjx=gal-next],[data-gjx-vtile],[data-gjx=vid-close],[data-gjx-addon],[data-gjx-addcart],[data-gjx=cta],[data-gjx=sticky-cta],[data-gjx=close-cta],[data-gjx-scrollbuy],[data-gjx-concern],[data-gjx-ing],[data-gjx-revchip],[data-gjx=rev-more],[data-gjx-bowlstep],[data-gjx-benefstop],[data-gjx=founder-tile]');
    if (!t) return;
    if (t.hasAttribute('data-gjx-mode')) { S.mode = t.getAttribute('data-gjx-mode'); S.bagAdj = 0; render(); track('gjx_mode', { mode: S.mode }); }
    else if (t.hasAttribute('data-gjx-protein')) { S.protein = t.getAttribute('data-gjx-protein'); render(); track('gjx_protein', { protein: S.protein }); }
    else if (t.hasAttribute('data-gjx-buytype')) { S.buyType = t.getAttribute('data-gjx-buytype'); render(); track('gjx_buytype', { type: S.buyType }); }
    else if (t.matches('[data-gjx=profile-chip]')) { S.editing = !S.editing; render(); }
    else if (t.hasAttribute('data-gjx-thumb')) { S.gal = +t.getAttribute('data-gjx-thumb'); render(); }
    else if (t.matches('[data-gjx=gal-prev]')) { var gp = galList(), ip = gp.indexOf(S.gal); S.gal = gp[(ip - 1 + gp.length) % gp.length]; render(); }
    else if (t.matches('[data-gjx=gal-next]')) { var gn = galList(), inx = gn.indexOf(S.gal); S.gal = gn[(inx + 1) % gn.length]; render(); }
    else if (t.hasAttribute('data-gjx-vtile')) { toggleVideo(+t.getAttribute('data-gjx-vtile')); }
    else if (t.matches('[data-gjx=vid-close]')) { closeVideo(); }
    else if (t.hasAttribute('data-gjx-addcart')) { addVariantToCart(t); }
    else if (t.hasAttribute('data-gjx-addon')) { var id = t.getAttribute('data-gjx-addon'); S.addons[id] = !S.addons[id]; render(); track('gjx_addon', { id: id, on: S.addons[id] }); }
    else if (t.matches('[data-gjx=cta]') || t.matches('[data-gjx=close-cta]')) { addToCart(t); }
    else if (t.matches('[data-gjx=sticky-cta]')) {
      if (window.matchMedia('(min-width:1024px)').matches) scrollToBuy(); else addToCart(t);
    }
    else if (t.hasAttribute('data-gjx-scrollbuy')) { scrollToBuy(); }
    else if (t.hasAttribute('data-gjx-concern')) { concernTap(+t.getAttribute('data-gjx-concern')); }
    else if (t.hasAttribute('data-gjx-ing')) { ingTap(+t.getAttribute('data-gjx-ing')); }
    else if (t.hasAttribute('data-gjx-revchip')) { revFilter(t.getAttribute('data-gjx-revchip')); }
    else if (t.getAttribute('data-gjx') === 'rev-more') { revExpanded = !revExpanded; revFilter(revTag); if (!revExpanded) { var rs = $('[data-gjx=rev-scroll]'); if (rs) rs.scrollIntoView({ block: 'start', behavior: 'smooth' }); } }
    else if (t.hasAttribute('data-gjx-bowlstep')) { bowlUser = true; setBowl(+t.getAttribute('data-gjx-bowlstep')); }
    else if (t.hasAttribute('data-gjx-benefstop')) { benefUser = true; setBenef(+t.getAttribute('data-gjx-benefstop')); }
    else if (t.matches('[data-gjx=founder-tile]')) { playFounder(t); }
  });

  // keyboard access for the video tiles rendered as role="button" divs
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-gjx=founder-tile]')) {
      e.preventDefault();
      playFounder(e.target);
    }
  });

  function scrollToBuy() {
    var bb = $('[data-gjx-buybox]');
    if (bb) bb.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---------- cart ---------- */
  // Open the store's cart drawer in place (Rebuy Smart Cart / theme drawer); falls back to /cart.
  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    try { if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') window.Rebuy.Cart.fetchCart(); } catch (e) {}
    var trig = document.querySelector('.js-drawer-open-cart');
    if (trig) trig.click(); else window.location.href = '/cart';
  }

  // Routine tiles: one-tap add of a single variant (treats / chews), then open the cart.
  function addVariantToCart(btn) {
    var vid = parseInt(btn.getAttribute('data-gjx-addcart'), 10);
    if (!vid) return;
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Cart error'); });
      return r.json();
    }).then(function () {
      track('gjx_routine_add', { variant: vid, name: btn.getAttribute('data-gjx-addname') || '' });
      btn.disabled = false; btn.textContent = '\u2713 In your cart'; btn.setAttribute('aria-pressed', 'true');
      setTimeout(function () { btn.textContent = orig; btn.setAttribute('aria-pressed', 'false'); }, 4000);
      openCart();
    }).catch(function (err) {
      btn.disabled = false; btn.textContent = orig;
      alertBar(err.message || 'Something went wrong \u2014 please try again.');
    });
  }

  // One meal plan per dog: adding a plan replaces that dog's existing plan line for this product (re-adding from the
  // quiz, the PDP, or after editing used to stack, e.g. 9 + 9 bags). Different dogs (different _dog_name) stay separate.
  function replacePlan(handle, dog) {
    dog = String(dog || '').trim();
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var up = {};
      (c.items || []).forEach(function (i) { if (i.handle === handle && i.final_line_price > 0 && String((i.properties || {})._dog_name || '').trim() === dog) up[i.key] = 0; });
      if (!Object.keys(up).length) return null;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: up }) });
    }).catch(function () { return null; });
  }
  function addToCart(btn) {
    var d = derived();
    var variantId = S.protein === 'beef' ? CFG.variants.beef : CFG.variants.chicken;
    if (!variantId) { console.warn('[gjx] missing variant id'); return; }
    var item = {
      id: parseInt(variantId, 10),
      quantity: d.bags,
      properties: {
        _dog_name: d.name || S.hName || '',
        _weight_lb: String(d.w),
        _mode: S.mode,
        _goals: (d.goals || []).join(','),
        _frequency_weeks: S.buyType === 'sub' ? String(S.freq) : '',
        _bags: String(d.bags),
        // Visible in the cart drawer, checkout, order emails and the subscription portal: a supply, not a bag count.
        Plan: ((d.name || S.hName) ? (d.name || S.hName) + "'s " : '') + (S.buyType === 'sub' ? S.freq + '-week supply' : '4-week supply') + (d.topper ? ' (topper)' : '')
      }
    };
    if (S.buyType === 'sub') {
      var plan = planFor(S.freq) || (S.freq === 4 ? parseInt(CFG.sellingPlanId, 10) : 0);
      if (!plan) { S.freq = 4; plan = parseInt(CFG.sellingPlanId, 10); } // never send a cadence we can't honor
      if (plan) item.selling_plan = plan;
    }
    var items = [item];
    (CFG.addons || []).forEach(function (ad) {
      if (S.addons[ad.id] && ad.variantId) items.push({ id: parseInt(ad.variantId, 10), quantity: 1 });
    });
    // Keep the inner label span (data-gjx=cta-label) intact: restore innerHTML, not textContent, or later price
    // re-renders can't find the span and the CTA freezes at the pre-add price.
    var orig = btn.innerHTML;
    btn.disabled = true; btn.textContent = 'Adding…';
    // Trial code goes on the cart BEFORE the add so the cart drawer (Rebuy auto-opens on add) renders the discounted price on first paint.
    var pre = replacePlan(CFG.handle || 'freeze-dried-raw', item.properties._dog_name).then(function () {
      return (S.buyType === 'otp' && CFG.trialCode)
        ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: CFG.trialCode }) }).catch(function () {})
        : null;
    });
    pre.then(function () { return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }); }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Cart error'); });
      return r.json();
    }).then(function () {
      track('gjx_add_to_cart', { bags: d.bags, protein: S.protein, mode: S.mode, type: S.buyType, weeks: S.buyType === 'sub' ? S.freq : 0, total: d.boxTotal });
      var after = function () {
        btn.disabled = false; btn.textContent = '\u2713 Added to cart'; setTimeout(function () { btn.innerHTML = orig; render(); }, 3000);
        openCart();
      };
      if (S.buyType === 'otp' && CFG.trialCode) {
        // Belt and braces: also set the classic discount cookie so checkout carries the code even if the cart-level apply was dropped.
        fetch('/discount/' + encodeURIComponent(CFG.trialCode), { credentials: 'same-origin' }).then(after, after);
      } else { after(); }
    }).catch(function (err) {
      btn.disabled = false; btn.innerHTML = orig; render();
      alertBar(err.message || 'Something went wrong — please try again.');
    });
  }
  function alertBar(msg) {
    var el = $('[data-gjx=cart-error]');
    if (el) { el.textContent = msg; el.hidden = false; setTimeout(function () { el.hidden = true; }, 5000); }
  }

  /* ---------- analytics ---------- */
  function track(ev, data) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: ev }, data || {})); } catch (e) { }
  }

  /* ---------- sticky bar visibility ---------- */
  (function () {
    var el = $('[data-gjx-buybox]');
    if (!el) return;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[entries.length - 1];
        var stick = !en.isIntersecting && en.boundingClientRect.bottom < 0;
        if (stick !== S.sticky) { S.sticky = stick; render(); }
      }, { threshold: 0 }).observe(el);
    } else {
      var onScroll = function () {
        var stick = el.getBoundingClientRect().bottom < 0;
        if (stick !== S.sticky) { S.sticky = stick; render(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
  })();

  /* ---------- video strip ---------- */
  var VIDEOS = CFG.videos || [];
  function sortVideos() {
    var d = derived();
    var g0 = d.goals[0];
    // Neil stays first (brand anchor); the tile matching the dog's top goal comes next; rest keep the configured order.
    var score = function (v) { return v.c === 'nph' ? 2 : (v.c === g0 || (v.c === 'senior' && d.stage === 'senior')) ? 1 : 0; };
    VIDEOS = VIDEOS.slice().sort(function (x, y) { return score(y) - score(x); });
    var grid = $('[data-gjx=vgrid]');
    if (!grid) return;
    grid.innerHTML = VIDEOS.map(function (v, i) {
      var media = v.src
        ? '<video src="' + v.src + '"' + (v.poster ? ' poster="' + v.poster + '"' : '') + ' muted playsinline preload="' + (v.poster ? 'none' : 'metadata') + '"></video>'
        : '<img src="' + v.poster + '" alt="" loading="lazy">';
      return '<button type="button" class="gjx-vtile" role="listitem" data-gjx-vtile="' + i + '" aria-label="Play review video: ' + String(v.tag).replace(/"/g, '') + '">' + media +
        '<span class="gjx-vtile-stars">★★★★★</span><span class="gjx-vtile-play"><svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" style="display:block"><path d="M3 1.8v8.4L10 6z" fill="currentColor"/></svg></span><span class="gjx-vtile-tag">' + v.tag + '</span></button>';
    }).join('');
    vcarSync();
  }
  // Carousel arrows (desktop/mouse only; touch swipes). Each click pages by the visible width.
  function vcarSync() {
    var g = $('[data-gjx=vgrid]'); if (!g) return;
    var prev = $('[data-gjx=vcar-prev]'), next = $('[data-gjx=vcar-next]');
    var max = g.scrollWidth - g.clientWidth - 2;
    if (prev) prev.hidden = g.scrollLeft <= 2;
    if (next) next.hidden = g.scrollLeft >= max;
  }
  (function () {
    var g = $('[data-gjx=vgrid]'); if (!g) return;
    g.addEventListener('scroll', function () { window.requestAnimationFrame(vcarSync); }, { passive: true });
    window.addEventListener('resize', vcarSync);
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gjx=vcar-prev],[data-gjx=vcar-next]'); if (!b) return;
      var dir = b.matches('[data-gjx=vcar-next]') ? 1 : -1;
      g.scrollBy({ left: dir * (g.clientWidth + 6), behavior: 'smooth' });
    });
  })();
  function toggleVideo(i) {
    if (S.vidOpen && S.vid === i) { closeVideo(); return; }
    S.vid = i; S.vidOpen = true;
    var v = VIDEOS[i];
    var wrap = $('[data-gjx=vplayer]');
    if (!wrap) return;
    wrap.hidden = false;
    var media = v.src
      ? '<video src="' + v.src + '"' + (v.poster ? ' poster="' + v.poster + '"' : '') + ' autoplay playsinline controls></video>'
      : '<img src="' + v.poster + '" alt=""><span class="gjx-vplayer-coming">Video coming</span>';
    wrap.innerHTML = '<div class="gjx-vplayer-frame"' + (v.poster ? ' style="--gjx-vposter:url(&quot;' + v.poster + '&quot;)"' : '') + '>' + media +
      '<button type="button" class="gjx-vplayer-close" data-gjx="vid-close" aria-label="Close video">×</button></div>' +
      '<div class="gjx-vplayer-meta"><div class="st">★★★★★</div><div class="q">' + v.quote + '</div><div class="w">' + (v.who || '✓ Verified Get Joy customer') + '</div></div>';
    $$('[data-gjx-vtile]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-gjx-vtile') === i ? 'true' : 'false'); });
  }
  function closeVideo() {
    S.vidOpen = false;
    var wrap = $('[data-gjx=vplayer]');
    if (wrap) { wrap.hidden = true; wrap.innerHTML = ''; }
    $$('[data-gjx-vtile]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
  }

  /* ---------- concerns (Block 2b) ---------- */
  var CONCERNS = CFG.concerns || [];
  var concernSel = null;
  function initConcerns() {
    if (!$('[data-gjx=concern-panel]')) return;
    var d = derived();
    var idx = d.isPlan ? (GOAL_TILE_IDX[d.goals[0]] != null ? GOAL_TILE_IDX[d.goals[0]] : 0) : 0;
    concernTap(idx, true);
  }
  function concernTap(i, silent) {
    concernSel = (concernSel === i && !silent) ? -1 : i;
    $$('[data-gjx-concern]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-gjx-concern') === concernSel ? 'true' : 'false'); });
    var panel = $('[data-gjx=concern-panel]');
    if (!panel) return;
    if (concernSel < 0) { panel.hidden = true; return; }
    var c = CONCERNS[concernSel];
    if (!c) { panel.hidden = true; return; }
    panel.hidden = false;
    setText('[data-gjx=concern-title]', c.title);
    setText('[data-gjx=concern-body]', c.body);
    var im = $('[data-gjx=concern-img]');
    if (im) im.src = c.illo;
    var prods = $('[data-gjx=concern-prods]');
    if (prods) {
      prods.innerHTML = (c.addons || []).map(function (id) {
        var ad = (CFG.addons || []).filter(function (x) { return x.id === id; })[0];
        if (!ad) return '';
        var on = !!S.addons[id];
        return '<div class="gjx-addon-row">' +
          (ad.img ? '<div class="im" style="background-image:url(\'' + ad.img + '\')"></div>' : '<div class="im im--ph"></div>') +
          '<div class="mid"><strong>' + ad.name + '</strong><div class="p">' + (ad.pair || ad.sub || '') + '</div></div>' +
          '<div class="r"><div class="pr">$' + parseFloat(ad.price).toFixed(2) + '</div>' +
          '<button type="button" class="gjx-add-btn" data-gjx-addon="' + id + '" aria-pressed="' + on + '">' + (on ? '\u2713 In first box' : '+ Add to box') + '</button></div></div>';
      }).join('');
    }
  }

  /* ---------- ingredients (Block 4) ---------- */
  var ING = CFG.ingredients || {};
  var ingSel = null;
  function ingTap(i) {
    ingSel = ingSel === i ? null : i;
    $$('[data-gjx-ing]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-gjx-ing') === ingSel ? 'true' : 'false'); });
    var flat = $('[data-gjx=ing-flat]'), panel = $('[data-gjx=ing-panel]');
    if (!panel) return;
    if (ingSel == null) { panel.hidden = true; if (flat) flat.hidden = false; return; }
    var list = ING[S.protein] || [];
    var d = list[ingSel];
    if (!d) return;
    panel.hidden = false;   // Oct 13 QA: the flatlay stays put; the detail panel opens under it
    setText('[data-gjx=ing-name]', d.label);
    setText('[data-gjx=ing-line]', d.line);
    var imWrap = $('[data-gjx=ing-panel-im]');
    if (imWrap) imWrap.innerHTML = d.img ? '<img src="' + d.img + '" alt="' + d.label + '">' : '<div class="ph" role="img" aria-label="' + d.label + '"></div>';
  }

  /* ---------- reviews filter (Block 3) ---------- */
  var revTag = 'all', revExpanded = false, REV_INITIAL = 8;
  function revFilter(tag) {
    revTag = tag;
    $$('[data-gjx-revchip]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-gjx-revchip') === tag ? 'true' : 'false'); });
    var shown = 0, hiddenByCap = 0;
    $$('[data-gjx-revtag]').forEach(function (card) {
      var match = tag === 'all' || card.getAttribute('data-gjx-revtag') === tag;
      var cap = tag === 'all' && !revExpanded && shown >= REV_INITIAL;
      card.hidden = !match || cap;
      if (match && !cap) shown++; else if (match && cap) hiddenByCap++;
    });
    var more = $('[data-gjx=rev-more]');
    if (more) { more.hidden = !(hiddenByCap > 0 || (revExpanded && tag === 'all')); more.textContent = revExpanded ? 'Show fewer' : 'Show more reviews (' + hiddenByCap + ')'; }
  }
  // Re-apply the desktop 8-card cap when the viewport crosses 1024 (tablet rotate, window resize).
  (function () { var wasDesk = window.innerWidth >= 1024, t; window.addEventListener('resize', function () {
    clearTimeout(t); t = setTimeout(function () { var isDesk = window.innerWidth >= 1024; if (isDesk !== wasDesk) { wasDesk = isDesk; revFilter(revTag); } }, 150); }); })();
  function sortReviews() {
    var d = derived();
    var match = { digestion: 'Digestion', skin: 'Skin & allergy', picky: 'Picky eater' }[d.goals[0]] || null;
    var wrap = $('[data-gjx=rev-scroll]');
    if (!wrap || !match) return;
    var cards = $$('[data-gjx-revtag]', wrap);
    cards.filter(function (c) { return c.getAttribute('data-gjx-revtag') === match; })
      .reverse().forEach(function (c) { wrap.insertBefore(c, wrap.firstChild); });
  }

  /* ---------- transition bowl (Block 5) ---------- */
  var bowlIdx = 0, bowlUser = false, BOWL_STEPS = [['Days 1–2', 25], ['Days 3–4', 50], ['Days 5–6', 75], ['Day 7+', 100]];
  function setBowl(i) {
    bowlIdx = i % 4;
    var st = BOWL_STEPS[bowlIdx];
    $$('[data-gjx-bowlstep]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-gjx-bowlstep') === bowlIdx ? 'true' : 'false'); });
    var mask = $('[data-gjx=bowl-mask]');
    if (mask) {
      var m = 'conic-gradient(#000 0 ' + st[1] + '%, transparent 0)';
      mask.style.webkitMaskImage = m; mask.style.maskImage = m;
      mask.style.animation = 'none'; void mask.offsetWidth; mask.style.animation = '';
    }
    setText('[data-gjx=bowl-when]', st[0]);
    setText('[data-gjx=bowl-pct]', st[1] + '% Get Joy · ' + (100 - st[1]) + '% current food');
  }
  if ($('[data-gjx=bowl-mask]')) {
    setBowl(0);
    setInterval(function () { if (!bowlUser) setBowl(bowlIdx + 1); }, 2600);
  }

  /* ---------- benefits timeline (Block 5b) ---------- */
  var BENEF = CFG.benefits || [];
  var benefIdx = 0, benefUser = false;
  function setBenef(i) {
    benefIdx = i % (BENEF.length || 5);
    var b = BENEF[benefIdx];
    if (!b) return;
    $$('[data-gjx-benefstop]').forEach(function (btn) { btn.setAttribute('aria-pressed', +btn.getAttribute('data-gjx-benefstop') === benefIdx ? 'true' : 'false'); });
    var card = $('[data-gjx=benef-card]');
    if (!card) return;
    card.innerHTML = '<div class="gjx-eyebrow">' + b.eyebrow + '</div><div class="gjx-benef-title">' + b.title + '</div>' +
      '<div class="gjx-benef-points"><span class="num">01</span><span><strong>' + b.p1 + '</strong><br>' + b.s1 + '</span>' +
      '<span class="num">02</span><span><strong>' + b.p2 + '</strong><br>' + b.s2 + '</span></div>';
    card.style.animation = 'none'; void card.offsetWidth; card.style.animation = '';
  }
  if ($('[data-gjx=benef-card]') && BENEF.length) {
    setBenef(0);
    setInterval(function () { if (!benefUser) setBenef(benefIdx + 1); }, 3500);
  }

  /* ---------- survey count-up (Block 2) ---------- */
  (function () {
    var nums = $$('[data-gjx-countup]');
    if (!nums.length || !('IntersectionObserver' in window)) { nums.forEach(function (n) { n.textContent = n.getAttribute('data-gjx-countup'); }); return; }
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || done) return;
        done = true; io.disconnect();
        var t0 = performance.now();
        (function step(now) {
          var p = Math.max(0, Math.min(1, (now - t0) / 1400)); // rAF timestamps can predate t0 — clamp so it never shows negatives
          var e = 1 - Math.pow(1 - p, 3);
          nums.forEach(function (n) { n.textContent = Math.round(+n.getAttribute('data-gjx-countup') * e); });
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      });
    }, { threshold: .4 });
    io.observe(nums[0]);
  })();

  /* ---------- founder video (Block 6) ---------- */
  function playFounder(tile) {
    var url = tile.getAttribute('data-gjx-video');
    if (!url) return;
    var v = document.createElement('video');
    v.src = url; v.controls = true; v.autoplay = true; v.playsInline = true;
    v.className = 'gjx-founder-video';
    tile.replaceWith(v);
  }

  /* ---------- boot ---------- */
  render();
  sortVideos();
  sortReviews();
  revFilter('all');
  initConcerns();
  track('gjx_pdp_view', { state: S.page, weight: S.weight, protein: S.protein, mode: S.mode });
})();

/* R49 · swipe the product gallery on touch (taps the matching arrow) */
(function () {
  if (window.__gjSwipe) return; window.__gjSwipe = 1;
  document.addEventListener('touchstart', function (e) {
    var s = e.target.closest && e.target.closest('.gjc-gal-stage,.gjx-gal-frame');
    if (!s || e.touches.length > 1) return;
    var x0 = e.touches[0].clientX, y0 = e.touches[0].clientY;
    function end(ev) {
      s.removeEventListener('touchend', end);
      var t = ev.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        var b = s.querySelector(dx < 0 ? '[class*="gal-arrow--next"]' : '[class*="gal-arrow--prev"]');
        if (b) b.click();
      }
    }
    s.addEventListener('touchend', end, { passive: true });
  }, { passive: true });
})();
